module.exports = __webpack_public_path__ + "img/rabbit-running.4cc24bbb.svg";